import React, { useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import ApiService from '../../../services/apiService';
import ItemGrid from './menuItem';
import Authorization from '../authorization';
import MessageGrid from '../../purchaseRequisition/messageGrid';
import { useSelector } from 'react-redux';
import { getCompany, getName, getUserId, getUserName } from '../../../../Redux/selecters';
import '../../../Assets/styles/addmenu.css';
import { RiRefreshLine } from 'react-icons/ri';
import { FaAngleLeft } from 'react-icons/fa6';
import { FaSave } from 'react-icons/fa';
import { ClipLoader } from 'react-spinners';
import Modal from 'react-bootstrap/Modal';
import Attachment from '../../Attachment/attachment';
import { useCurrency } from '../../../../INVENTORY/Layouts/currencyContext';



const createEmptyRow = () => ({
    id: Date.now() + Math.random(),
    file: null,
    fileName: "",
    remarks: "",
});

const CreatePurchaseOrderTwo = () => {
    const REPORT_URL = process.env.REACT_APP_REPORTS_URL;
    const [activeTab, setActiveTab] = useState(0);
    const [SupplierTab, setSupplierTab] = useState(false);
    const [POTab, setPOTab] = useState(true);
    const [CostTab, setCostTab] = useState(false);
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const [messageData, setMessageData] = useState([]);
    const [authorizationData, setAuthorizationData] = useState([]);
    const [ItemsData, setRequisitionData] = useState([]);
    const { currencyPrecision } = useCurrency();
    const [suppliers, setSupplier] = useState([]);
    const [payments, setPayments] = useState([]);
    const [SelectedCurrency, setSelectedCurency] = useState([]);
    const [usersDetails, setUser] = useState([]);
    const [Supplier, setSupplierData] = useState([]);
    const [SupplierID, setSupplierID] = useState([]);
    const [isVatExcluded, setIsVatExcluded] = useState(false);
    const [isDiscountPercentage, setIsDiscountPercentage] = useState(true);
    const [SupplierContact, setSupplierContact] = useState();
    const [Payment, setPayment] = useState([]);
    const [poNumber, setPONumber] = useState([]);
    const [cost1, setCost1] = useState([]);
    const [cost2, setCost2] = useState([]);
    const [cost3, setCost3] = useState([]);
    const [cost4, setCost4] = useState([]);
    const [contactNumber, setContactNumber] = useState();
    const [loder, setLoader] = useState(false);
    const [apiData, setApiData] = useState([]);

    // New state for direct PO data and selected requisition
    const [directPOData, setDirectPOData] = useState([]);
    const [selectedRequisition, setSelectedRequisition] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();
    const [loader, setLoadr] = useState(false);
    const userId = useSelector(getUserId);
    const userName = useSelector(getUserName);
    const Company = useSelector(getCompany);
    const itemData = location.state;
    const [itemList, setItemData] = useState([]);
    const currentDatetimeUTC = new Date().toISOString().slice(0, 16);
    const onOpenModal = () => setDocModal(true);
    const onCloseModal = () => setDocModal(false);
    const apiService = new ApiService();


    // Attachment
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [docModal, setDocModal] = useState(false);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [attachments, setAttachments] = useState([createEmptyRow()]);
    const openModal = () => setAttachmentModal(true);
    const closeModal = () => setAttachmentModal(false);

    const isReadOnly = itemData?.eye === true;
    const [isXtreamCompany, setXtreamCompany] = useState(false);

    const getCurrentLocalDatetime = () => {
        const localDate = new Date();
        const offset = localDate.getTimezoneOffset() * 60000;
        const localISOTime = new Date(localDate - offset).toISOString().slice(0, 16);
        return localISOTime;
    };

    useEffect(() => {
        checkCompanyName();
    }, [Company]);

    useEffect(() => {
        fetchCostCenter();
        fetchDirectPO();
        fetchSuppliers();
    }, []);

    useEffect(() => {
        fetchData()
    }, [isXtreamCompany]);

    const [formData, setFormData] = useState({
        PayOrderNo: '',
        Remarks: '',
        DocumentDate: getCurrentLocalDatetime(),
        SupplierContact: '',
        deliveryDate: getCurrentLocalDatetime(),
        deliveryPoint: '',
        location: '',
        contactPerson: '',
        requisitionNo: '',
        lPOType: { label: "Commercial", value: "Commercial" },
        RequisitionType: '',
        ContactNo: '',
        costCenter1: '',
        costCenter2: '',
        costCenter3: '',
        costCenter4: '',
        CostCentre5: '',
        currencyCode: '',
        QuotationReq: '',
        exchangeRate: '',
        Description: '',
        BuyerName: '',
        vendorId: '',
        vendorName: '',
        OrderType: [],
        paymentTerm: [],
        SupplierDep: [],
    });

    // New function to fetch Direct PO data
    const fetchDirectPO = async () => {
        try {
            const apiService = new ApiService();
            let param = `?dropdownTypes=DirectPORequisitionNos`;
            const response = await apiService.getApiParamater('GET_DIRECT_PO', param);
            console.log('API Response:', response); // Add this to debug
            setDirectPOData(response?.data?.dropdowns?.DirectPORequisitionNos || []);
        } catch (error) {
            console.error('Error fetching Direct PO data:', error);
        }
    };

    // Updated fetchPCData function in CreatePurchaseOrder component
    const fetchPCData = async (item) => {
        try {
            setLoader(true)
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('Id', item?.requisitionNo || item);
            params.append('PageNo', 1);
            params.append('PageSize', 1);
            const response = await apiService.getApiParamater('GET_PR', `?${params.toString()}`);
            const SelectedReq = response?.data?.result[0];

            const payresponse = await apiService.get('GET_EPAYMENT');
            const selectedpaymentTerm = payresponse?.data?.result?.find((payment) => payment?.description === item?.paymentTerms);
            if (selectedpaymentTerm) {
                setPayment({ label: selectedpaymentTerm?.description, value: selectedpaymentTerm });
            }

            const supplierResponse = await apiService.get('GET_SUPPLIER_KANOO');
            const selectedSuplier = supplierResponse?.data?.result?.find((sup) => sup?.supplierName === item?.vendorName);
            if (selectedSuplier) {
                setSupplierData({ label: selectedSuplier?.supplierName, value: selectedSuplier });
                setSupplierID({ label: selectedSuplier?.supplier_ID, value: selectedSuplier });
                setSupplierContact(selectedSuplier?.phoneNo1);
            }

            setIsVatExcluded(SelectedReq?.costCenter5);
            setContactNumber(SelectedReq?.contatNo);
            setFormData({
                requisitionNo: item.requisitionNo || item,
                Remarks: SelectedReq?.remarks,
                requestor: SelectedReq?.requestor,
                requisitionDate: SelectedReq?.requisitionDate || currentDatetimeUTC,
                deliveryDate: SelectedReq?.deliveryDate || currentDatetimeUTC,
                Department: SelectedReq?.department,
                deliveryPoint: SelectedReq?.deliveryPoint,
                contactPerson: SelectedReq?.contactPerson,
                location: SelectedReq?.location,
                QuotationReq: SelectedReq?.pcNo,
                RequisitionType: SelectedReq?.type,
                costCenter1: { label: SelectedReq?.costCenter1, value: SelectedReq?.costCenter1 },
                costCenter2: { label: SelectedReq?.costCenter2, value: SelectedReq?.costCenter2 },
                costCenter3: { label: SelectedReq?.costCenter3, value: SelectedReq?.costCenter3 },
                costCenter4: { label: SelectedReq?.costCenter4, value: SelectedReq?.costCenter4 },
            });

            // Structure the data properly for ItemGrid component
            const structuredItemData = {
                requisitionNo: SelectedReq?.requisitionNo || item,
                vendorName: SelectedReq?.vendorName,
                vendorId: SelectedReq?.vendorId,
                // Map prDetails to items format expected by ItemGrid
                items:
                    SelectedReq?.prDetails?.map((detail) => ({
                        itemCode: detail.itemCode,
                        itemDescription: detail.itemDescription,
                        qty: detail.qty,
                        srno: detail?.srno,
                        uom: detail.uom,
                        price: detail.unitPrice, // Note: ItemGrid expects 'price' but API returns 'unitPrice'
                        baseQty: detail.baseQty,
                        specification: detail.specification,
                        discount: 0, // Set default discount if not provided
                        // Add any other properties that ItemGrid might need
                    })) || [],
                // Include the original prDetails for reference if needed
                prDetails: SelectedReq?.prDetails,
                // Add flags for ItemGrid logic
                eye: false, // Set based on your business logic
                pOrderNo: '', // Set if this is coming from a PO, otherwise leave empty
            };

            setItemData(structuredItemData);
        } catch (error) {
            console.error('Error fetching PC data:', error);
        }
    };

    // Handle requisition selection from dropdown
    const handleRequisitionChange = (selectedOption) => {
        setSelectedRequisition(selectedOption);
        if (selectedOption && selectedOption.value) {
            fetchPCData(selectedOption.value);
        }
    };

    useEffect(() => {
        const item = location.state;
        const fetchPC = async () => {
            try {
                if (item.requisitionNo) {
                    await fetchPCData(item);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        if (item?.requisitionNo) {
            fetchPC();
        }
    }, [location.state]);


    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    };

    const handleMessage = (data) => {
        setMessageData(data);
        console.log(data, 'reqData');
    };

    const handleRequisitionData = (data) => {
        setRequisitionData(data);
        console.log(data, 'reqData');
    };

    const handleAuthorization = (data) => {
        setAuthorizationData(data);
        console.log(data, 'reqData');
    };

    const handlecurChange = (selectedOption) => {
        setFormData({ ...formData, currencyCode: selectedOption?.value?.code });
    };

    const handleVatChange = () => {
        setIsVatExcluded(!isVatExcluded);
    };

    const handleContactChange = (e) => {
        const { name, value } = e.target;
        if (name === 'ContactNo' && value.length > 16) {
            return;
        }
        if (name === 'ContactNo' && value < 0) {
            return;
        }
        setContactNumber(e.target.value);
    };

    const handleDiscountChange = () => {
        setIsDiscountPercentage(!isDiscountPercentage);
    };

    const orderType = [
        { value: 'None', label: 'None' },
        { value: 'Local Purchase', label: 'Local Purchase' },
        { value: 'Import Purchase', label: 'Import Purchase' },
        { value: 'Fixed Assist Purchase', label: 'Fixed Assist Purchase' },
        { value: 'Non Inventory Purchase', label: 'Non Inventory Purchase' },
        { value: 'Hire Purchase', label: 'Hire Purchase' },
        { value: 'Internal Pay Order', label: 'Internal Pay Order' },
        { value: 'Open Pay Order', label: 'Open Pay Order' },
    ];

    const itemType = [
        { value: 'None', label: 'None' },
        { value: 'Inventory', label: 'Inventory' },
        { value: 'Fixed Asset', label: 'Fixed Asset' },
        { value: 'Services', label: 'Services' },
    ];

    const LPOType = [
        { value: 'Commercial', label: 'Commercial' },
        { value: 'Family', label: 'Family' },
    ];
    let param = `?isActive=true`;

    const GenerateNumber = async () => {
        let docParam = `?TypeOfDoc=Pur&DocId=POrder`;
        const docRes = await apiService.getApiParamater('GET_DOC_ID', docParam);
        setPONumber(docRes?.data.result[0].docId);
        onCloseModal();
    };

    const fetchCostCenter = async () => {
        try {
            let cost1 = await apiService.get('GET_COST_ONE');
            setCost1([{ value: null, description: 'None' }, ...cost1?.data?.result]);
            let cost2 = await apiService.get('GET_COST_TWO');
            setCost2([{ value: null, description: 'None' }, ...cost2?.data?.result]);
            let cost3 = await apiService.get('GET_COST_THREE');
            setCost3([{ value: null, description: 'None' }, ...cost3?.data?.result]);
            // let cost4 = await apiService.get('GET_COST_FOUR');
            // setCost4([{ value: null, description: 'None' }, ...cost4?.data?.result]);
        } catch (error) {
            console.error('Error fetching Cost Center data:', error);
        }
    };

    const fetchSuppliers = async () => {
        try {
            const supplierResponse = await apiService.get('GET_SUPPLIER_KANOO');
            setSupplier(supplierResponse?.data?.result);
            const response = await apiService.get('GET_EPAYMENT');
            setPayments([{ value: null, description: 'None' }, ...response?.data?.result]);
            if (currencyPrecision) {
                setSelectedCurency({ label: currencyPrecision.code, value: currencyPrecision });
            }
            setFormData({
                exchangeRate: currencyPrecision?.conversionRate,
            });
        } catch (error) {
            console.error('Error fetching Cost Center data:', error);
        }
    };

    const fetchData = async () => {
        try {
            const apiService = new ApiService();
            if (isXtreamCompany) {
                let docParam = `?TypeOfDoc=${formData?.lPOType?.label}&DocId=POrder`
                let DocId = await apiService.getApiParamater('GET_DOC_ID', docParam)
                setPONumber(DocId?.data.result[0].docId);
                const params = new URLSearchParams();
                params.append('DocNo', '');
                params.append('DocumentType', "POrder");
                const editresponse = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
                setUser(editresponse.data.result);
            } else {
                let docParam = `?TypeOfDoc=Pur&DocId=POrder`
                let DocId = await apiService.getApiParamater('GET_DOC_ID', docParam)
                setPONumber(DocId?.data.result[0].docId);
                const params = new URLSearchParams();
                params.append('DocNo', '');
                params.append('DocumentType', "POrder");
                const editresponse = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
                setUser(editresponse.data.result);
            }


        } catch (error) {
            console.error("Error fetching Currency data:", error);
        }
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'SupplierContact' && value.length > 16) {
            return;
        }
        if (name === 'SupplierContact' && value < 0) {
            return;
        }
        if (name === 'deliveryDate' || name === 'DocumentDate') {
            const dateParts = e.target.value.split('-');
            if (dateParts[0].length > 4) {
                return;
            }
        }
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handlePayChange = (selectedOption) => {
        setPayment(selectedOption);
    };

    const handleSupplierChange = (selectedOption) => {
        setSupplierData({ label: selectedOption?.value?.supplierName, value: selectedOption });
        setSupplierID({ label: selectedOption?.value?.supplier_ID, value: selectedOption });
        setSupplierContact(selectedOption?.value?.phoneNo1);
        setPayment({ label: selectedOption?.value?.paymentTerm, value: selectedOption });
    };

    const handleDepChange = (selectedOption) => {
        setFormData({ ...formData, SupplierDep: selectedOption });
    };

    const handlePyorderChange = (selectedOption) => {
        setFormData({ ...formData, OrderType: selectedOption });
    };

    const CreatePO = async () => {
        setLoadr(true);
        if (ItemsData.length === 0) {
            toast.warning('Please add items');
            setLoadr(false);
            return;
        } else if (!Supplier.label) {
            toast.warning('Please Select Supplier');
            setLoadr(false);
            return;
        }
        for (const item of ItemsData) {
            if (!item.itemDescription) {
                toast.warning(`Please Select Item`);
                setLoadr(false);
                return;
            } else if (!item.qty) {
                toast.warning(`Please enter ${item.itemDescription} quantity`);
                setLoadr(false);
                return;
            } else if (!item.qty || parseFloat(item.qty) <= 0) {
                toast.warning(`${item.itemDescription} quantity must be greater than 0`);
                setLoadr(false);
                return;
            } else if (!item.baseAmount || parseFloat(item.baseAmount) <= 0) {
                toast.warning(`${item.itemDescription} unit price must be greater than 0`);
                setLoadr(false);
                return;
            }
        }
        const totalAmount = ItemsData.reduce((sum, row) => sum + (parseFloat(row?.amount) || 0), 0);
        try {
            const apiService = new ApiService();
            const currentDatetimeUTC = new Date().toISOString();

            const prDetailsData = ItemsData.map((item, index) => ({
                pOrderNo: poNumber,
                deliveryDate: formData.deliveryDate,
                status: 0,
                isActive: true,
                vatPerc: item?.vat,
                vatDesc: item?.vatDec,
                vatAmount: parseFloat(Number(item.vatAmount).toFixed(SelectedCurrency?.value?.precision || 2)),
                vatUnitPrice: parseFloat(Number(item.vatAmount / item.qty).toFixed(SelectedCurrency?.value?.precision || 2)),
                vatBaseAmount: parseFloat(Number(item.vatAmount).toFixed(SelectedCurrency?.value?.precision || 2)),
                requisitionNo: selectedRequisition?.value || itemData?.requisitionNo || '',
                srno: item?.srno,
                rsrno: index + 1,
                itemCode: item.ItemNo || item.recordId,
                itemDescription: item.itemDescription,
                uom: item.uom,
                qty: parseFloat(item.qty),
                baseUOM: item?.uom,
                baseQty: parseFloat(item.baseQty),
                specification: item.specification,
                convValue: parseFloat(item?.baseQty),
                unitPrice: parseFloat(Number(item.baseAmount).toFixed(SelectedCurrency?.value?.precision || 2)),
                amount: parseFloat(Number(item.amount).toFixed(SelectedCurrency?.value?.precision || 2)),
                baseAmount: parseFloat(Number(item.amount).toFixed(SelectedCurrency?.value?.precision || 2)),
                discount: parseFloat(item.discount),
                discountPerc: isDiscountPercentage === true ? 1 : 0,
                cancelledQty: 0,
                returnQty: 0,
            }));
            const userData = {
                pOrderNo: poNumber,
                docId: itemData?.vendorName ? formData.RequisitionType : formData.RequisitionType?.label,
                terms: Payment.label,
                vendorId: SupplierID?.label.toString(),
                vendorName: Supplier?.label,
                fax: formData?.lPOType?.label || "0",
                contractNo: contactNumber,
                docDate: currentDatetimeUTC,
                attention: SupplierContact,
                location: formData?.location,
                currencyCode: SelectedCurrency?.label,
                exchangeRate: SelectedCurrency?.value.conversionRate,
                requisitionNo: selectedRequisition?.value || itemData?.requisitionNo || '',
                department: formData?.Department,
                deliveryPoint: formData?.deliveryPoint,
                contactPerson: formData?.contactPerson,
                status: 0,
                description: formData?.Description,
                modifiedBy: userName,
                modifiedOn: currentDatetimeUTC,
                remarks: formData?.Remarks,
                costCenter1: formData?.costCenter1?.label,
                costCenter2: formData?.costCenter2?.label,
                costCenter3: formData?.costCenter3?.label,
                costCenter4: formData?.costCenter4?.label,
                poType: 'POrder',
                isActive: true,
                deliveryDate: formData.deliveryDate || currentDatetimeUTC,
                poDetails: prDetailsData,
                costCenter5: isVatExcluded === true ? 'excluded' : 'Included',
                baseAmount: Number(totalAmount).toFixed(SelectedCurrency?.value?.precision || 2),
                amount: Number(totalAmount).toFixed(SelectedCurrency?.value?.precision || 2),
                quotationRef: formData?.QuotationReq,
            };
            const response = await apiService.post('CREATE_PO', userData);
            if (response?.data?.statusCode === 201) {
                const userData2 = {
                    docType: 'POrder',
                    docId: poNumber,
                    department: 'IT',
                    company: Company?.selectedCompany?.companyNo,
                    userCode: userId,
                    userName: userName,
                };
                const docBody = {
                    docId: 'POrder',
                    typeOfDoc: 'Pur',
                };
                const docRes = await apiService.put('UPDATE_DOC_ID', docBody);
                if (attachments) {
                    handleUpload()
                }
                const response2 = await apiService.post('CREATE_DOC_AUTHORIZATION', userData2);
                const paramsGet = new URLSearchParams();
                paramsGet.append('docType', 'POrder');
                paramsGet.append('docId', poNumber);
                paramsGet.append('srno', 1);
                const response3 = await apiService.getApiParamater('GET_DOC_APPROVAL_USER', `?${paramsGet.toString()}`);
                if (response3?.data?.result.length > 0) {
                    const toEmails = response3?.data?.result?.map((user) => user.userEmail);
                    const emailbody = {
                        toEmails: toEmails,
                        subject: 'Purchase Order',
                        body: '',
                        docNo: poNumber,
                        srNo: 1,
                        docType: 'POrder',
                    };
                    const emailres = await apiService.post('DOC_APPROVAL_EMAIL_POST', emailbody);
                }
                const token = localStorage.getItem('Token');
                const DB = localStorage.getItem('DataBase');
                if (!token) {
                    alert('Auth token is missing! Unable to proceed.');
                    return;
                }
                const popupWidth = 1000;
                const popupHeight = 600;
                const popupLeft = (window.screen.width - popupWidth) / 2;
                const popupTop = (window.screen.height - popupHeight) / 2;
                const popup = window.open(
                    '',
                    'ReportPopup',
                    `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
                );

                if (popup) {
                    const form = document.createElement('form');
                    form.method = 'POST';
                    form.action = REPORT_URL;
                    form.target = 'ReportPopup';

                    const inputs = [
                        { name: 'authToken', value: token },
                        { name: '_db', value: DB },
                        { name: 'reportName', value: 'POrder' },
                        { name: 'voucherNo', value: poNumber },
                    ];

                    inputs.forEach(({ name, value }) => {
                        const input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = name;
                        input.value = value;
                        form.appendChild(input);
                    });

                    document.body.appendChild(form);
                    form.submit();
                    document.body.removeChild(form);
                }
                setLoadr(false);
                toast.success(`${poNumber} Created successfully`);
                navigate('/inventory/Purchase/Order');
            } else if (response?.data?.statusCode === 208) {
                setLoadr(false);
                onOpenModal();
            }
        } catch (error) {
            setLoadr(false);
            console.error('Error Creating PO:', error);
        }
    };

    const handleCost1 = async (selectedOption) => {
        let param = `?CostCenter1=${selectedOption?.label}`
        let cost2 = await apiService.getApiParamater('GET_COST_TWO', param)
        if (cost2?.data?.result) {
            setCost2([{ value: null, description: 'None' }, ...cost2?.data?.result]);
        } else {
            setCost2([])
        }
        setFormData({ ...formData, costCenter1: selectedOption });
    };

    const handleCost2 = (selectedOption) => {
        setFormData({ ...formData, costCenter2: selectedOption });
    };

    const handleCost3 = (selectedOption) => {
        setFormData({ ...formData, costCenter3: selectedOption });
    };

    const handleCost4 = (selectedOption) => {
        setFormData({ ...formData, costCenter4: selectedOption });
    };

    const handleBackClick = () => {
        window.history.back();
    };

    const handleItemTypeChange = (selectedOption) => {
        setFormData({ ...formData, RequisitionType: selectedOption });
    };

    const preventNegativeSign = (e) => {
        if (e.key === '-') {
            e.preventDefault();
        }
    };

    // Attachment Functions
    const handleFileSelect = useCallback((file, id) => {
        setAttachments((prev) => {
            const updated = prev.map((row) =>
                row.id === id ? { ...row, file, fileName: file.name } : row
            );
            return [...updated, createEmptyRow()];
        });
    }, []);
    const handleRemarkChange = (id, value) => {
        setAttachments((prev) =>
            prev.map((row) =>
                row.id === id ? { ...row, remarks: value } : row
            )
        );
    };
    const handleDelete = (id) => {
        setAttachments((prev) => prev.filter((row) => row.id !== id));
    };
    const handleView = (file) => {
        if (!file) return;

        if (isReadOnly) {
            setPreviewImage(file);
        } else {
            setPreviewImage(URL.createObjectURL(file));
        }
        setPreviewModal(true);
    };
    const handleUpload = async () => {
        const formData = new FormData();

        attachments.forEach(({ file }) => {
            if (file instanceof File) {
                formData.append("Images", file, file.name);
            }
        });

        const response = await apiService.postMultiPart(
            "UPLOAD_FILE",
            formData
        );

        if (response?.data?.statusCode === 201 && response?.data?.isSuccessful) {
            const uploadedFileNames = response.data.result.split(",");

            const payload = {
                docFilesDtos: attachments
                    .filter((a) => a.file)
                    .map((a, index) => ({
                        srno: index + 1,
                        docNo: poNumber,
                        docType: "PurchaseOrder",
                        fileName: uploadedFileNames[index]?.trim(),
                        remarks: a.remarks || "",
                    })),
            };

            await apiService.post("CREATE_ATTACHMENT", payload);
            return
        }
    };

    const checkCompanyName = () => {
        const DB = localStorage.getItem('DataBase');
        const companies = JSON.parse(localStorage.getItem('UserCompanies') || '[]');
        const defaultCompany = companies.find(comp => comp.dataDB === DB);
        const companyName = defaultCompany?.companyName?.toLowerCase() || '';
        const isXtreamCashier = companyName.includes('accountcode') || companyName.includes('kanoo');
        setXtreamCompany(isXtreamCashier);
    };

    const handleTypeChange = async (selectedOption) => {
        setFormData({ ...formData, lPOType: selectedOption });
        let docParam = `?TypeOfDoc=${selectedOption?.label}&DocId=POrder`
        let DocId = await apiService.getApiParamater('GET_DOC_ID', docParam)
        setPONumber(DocId?.data.result[0].docId);
        const params = new URLSearchParams();
        params.append('DocNo', '');
        params.append('DocumentType', "POrder");
        const editresponse = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
        setUser(editresponse.data.result);
    };
    return (
        <div className="px-4">
            <div className="d-flex justify-content-between pt-3">
                <h5 className="col mainInvHead">Purchase Order</h5>
                <div className="d-flex gap-3">
                    {loader === true ? (
                        <button className="mainbtn " type="submit">
                            <ClipLoader color="#ffffff" size={25} />
                        </button>
                    ) : (
                        <button className="mainbtn " type="submit" onClick={CreatePO}>
                            <FaSave className="center mt-1 mx-2" />
                            <div>Save</div>
                        </button>
                    )}
                    <button className="mainbtnRed">
                        <RiRefreshLine className="center mt-1 mx-2" />
                        <div>Reset</div>
                    </button>
                    <button onClick={handleBackClick} className="mainbtnSecondary">
                        <FaAngleLeft className="center mt-1 mx-2" />
                        <div>Back</div>
                    </button>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setPOTab(!POTab)}>
                    <div className="h6 pt-1">Purchase Order Details</div>
                </div>
                <div className={`slide-content ${POTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${POTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group justify-content-between row pb-3">
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="RequisitionType" className="form-label center">LPO Type</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    value={formData.lPOType}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    options={LPOType}
                                    onChange={(selectedOption) => handleTypeChange(selectedOption)}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="InvoiceNO" className="form-label center">
                                    Purchase Order No
                                </label>
                                <input className="form-Input w-70" value={poNumber} name="poNumber" disabled />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="DeliveryDate" className="form-label center">
                                    Delivery Date
                                </label>
                                <input
                                    type="datetime-local"
                                    className="form-Input w-70"
                                    id="DeliveryDate"
                                    value={formData.deliveryDate}
                                    onChange={handleInputChange}
                                    name="deliveryDate"
                                />
                            </div>
                        </div>
                        <div className="form-group row justify-content-between pb-3">
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="Currency" className="form-label center">
                                    Currency{' '}
                                </label>
                                <Select
                                    isSearchable={false}
                                    value={SelectedCurrency}
                                    className="w-70 p-0"
                                    onChange={(e) => handlecurChange(e)}
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="DocumentDate" className="form-label center">
                                    Document Date
                                </label>
                                <input
                                    className="form-Input w-70"
                                    id="DocumentDate"
                                    value={formData.DocumentDate}
                                    type="datetime-local"
                                    defaultValue={new Date().toISOString().substr(0, 10)}
                                    name="DocumentDate"
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="deliveryPoint" className="form-label center">
                                    Delivery Point
                                </label>
                                <input
                                    type="text"
                                    className="form-Input w-70"
                                    id="deliveryPoint"
                                    value={formData?.deliveryPoint}
                                    onChange={handleInputChange}
                                    name="deliveryPoint"
                                />
                            </div>
                        </div>
                        <div className="form-group row justify-content-between pb-3">
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="ExchangeRate" className="form-label center">
                                    Exchange Rate{' '}
                                </label>
                                <input type="text" className="form-Input w-70" disabled id="exchangeRate" value={formData.exchangeRate} name="exchangeRate" />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="requisitionNo" className="form-label center">
                                    Requisition No
                                </label>
                                <Select
                                    className="w-70 p-0"
                                    value={selectedRequisition}
                                    options={directPOData?.map((po) => ({
                                        value: po.value,
                                        label: po.text,
                                    }))}
                                    onChange={handleRequisitionChange}
                                    isDisabled={itemData?.vendorName ? true : false}
                                    isClearable
                                    placeholder="Select Requisition Number"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="location" className="form-label center">
                                    Location
                                </label>
                                <input type="text" className="form-Input w-70" id="location" value={formData.location} onChange={handleInputChange} name="location" />
                            </div>
                        </div>
                        <div className="form-group row justify-content-between pb-3">
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="Description" className="form-label center">
                                    Description
                                </label>
                                <input type="text" className="form-Input w-70" id="Description" value={formData.Description} onChange={handleInputChange} name="Description" />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="RequisitionType" className="form-label center">
                                    Requisition Type
                                </label>
                                {itemData?.vendorName ? (
                                    <input
                                        type="text"
                                        className="form-Input w-70"
                                        id="RequisitionType"
                                        disabled
                                        value={formData.RequisitionType}
                                        onChange={handleInputChange}
                                        name="RequisitionType"
                                    />
                                ) : (
                                    <Select
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9,
                                        })}
                                        value={formData.RequisitionType}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        className="w-70 p-0"
                                        menuPlacement="auto"
                                        menuShouldScrollIntoView={false}
                                        options={itemType}
                                        onChange={(selectedOption) => handleItemTypeChange(selectedOption)}
                                    />
                                )}
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="contactPerson" className="form-label center">
                                    Contact Person
                                </label>
                                <input
                                    type="text"
                                    className="form-Input w-70"
                                    id="contactPerson"
                                    value={formData.contactPerson}
                                    onChange={handleInputChange}
                                    name="contactPerson"
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="Remarks" className="form-label center">
                                    Remarks
                                </label>
                                <input type="text" className="form-Input w-70" id="Remarks" value={formData.Remarks} onChange={handleInputChange} name="Remarks" />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="QuotationReq" className="form-label center">
                                    Quotation Req
                                </label>
                                <input
                                    type="text"
                                    className="form-Input w-70"
                                    id="QuotationReq"
                                    disabled
                                    value={formData.QuotationReq}
                                    onChange={handleInputChange}
                                    name="QuotationReq"
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="ContactNo" className="form-label center">
                                    Contact No
                                </label>
                                <input
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    className="form-Input w-70"
                                    id="ContactNo"
                                    value={contactNumber}
                                    onKeyDown={preventNegativeSign}
                                    onChange={handleContactChange}
                                    name="ContactNo"
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="Description" className="form-label center">
                                    Pay OrderType
                                </label>
                                <Select
                                    options={orderType}
                                    value={formData.OrderType}
                                    className="w-70 p-0"
                                    onChange={(selectedOption) => handlePyorderChange(selectedOption)}
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 8,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                />
                            </div>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="BuyerName" className="form-label center">
                                    Buyer Name
                                </label>
                                <input type="text" className="form-Input w-70" id="BuyerName" value={formData.BuyerName} onChange={handleInputChange} name="BuyerName" />
                            </div>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="BuyerName" className="form-label">Delivery Note No</label>
                                <input
                                    type="text" disabled={itemData.eye === true ? true : false}
                                    className="form-Input w-70"
                                    id="deliveryNote"
                                    value={formData.deliveryNote}
                                    onChange={handleInputChange}
                                    name="deliveryNote"
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col-2 p-2 brderbox center" onClick={() => openModal()}>
                                {'Attachment'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setSupplierTab(!SupplierTab)}>
                    <div className="h6 pt-1">Supplier Details</div>
                </div>
                <div className={`slide-content ${SupplierTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className="form-group row  pb-3">
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label center">
                                    Vendor ID
                                </label>
                                <Select
                                    value={SupplierID}
                                    isDisabled={itemData?.vendorName ? true : false}
                                    options={suppliers?.map((sup) => ({ value: sup, label: sup?.supplier_ID }))}
                                    onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                                    className="w-70 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label center">
                                    Vendor Name
                                </label>
                                <Select
                                    value={Supplier}
                                    className="w-70 p-0"
                                    isDisabled={itemData?.vendorName ? true : false}
                                    options={suppliers?.map((sup) => ({ value: sup, label: sup?.supplierName }))}
                                    onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label center">
                                    Payment terms
                                </label>
                                <Select
                                    className="w-70 p-0"
                                    value={Payment}
                                    isDisabled={itemData?.vendorName ? true : false}
                                    onChange={(selectedOption) => handlePayChange(selectedOption)}
                                    options={payments?.map((sup) => ({ value: sup, label: sup?.description }))}
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                />
                            </div>
                        </div>
                        <div className="form-group row  pb-3">
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label center">
                                    Vendor Dept
                                </label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    isDisabled={itemData?.vendorName ? true : false}
                                    value={formData.SupplierDep}
                                    onChange={(selectedOption) => handleDepChange(selectedOption)}
                                />
                            </div>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="Property" className="form-label center">
                                    Vendor Contact
                                </label>
                                <input
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    className="form-Input w-70"
                                    id="SupplierContact"
                                    disabled={itemData?.vendorName ? true : false}
                                    value={SupplierContact}
                                    onChange={handleInputChange}
                                    name="SupplierContact"
                                />
                            </div>
                            <div className="col-4 pt-1 d-flex justify-content-between">
                                <div className="d-flex justify-content-between">
                                    <div className="form-check">
                                        <input
                                            style={{ width: '26px', height: '26px' }}
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={isVatExcluded}
                                            onChange={handleVatChange}
                                        />
                                        <label className="form-check-label mx-2 mt-1">Vat Excluded</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setCostTab(!CostTab)}>
                    <div className="h6 pt-1">Cost Center Details</div>
                </div>
                <div className={`slide-content ${CostTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className="form-group row justify-content-between pb-3">
                            <div className="col-md-4 d-flex align-items-center">
                                <label htmlFor="costCenter1" className="form-label me-2">
                                    Property
                                </label>
                                <Select
                                    id="costCenter1"
                                    value={formData.costCenter1}
                                    isDisabled={!!itemData?.vendorName}
                                    onChange={handleCost1}
                                    options={cost1?.map((sup) => ({ value: sup, label: sup?.description }))}
                                    className="flex-grow-1"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 8,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                />
                            </div>
                            <div className="col-md-4 d-flex align-items-center">
                                <label htmlFor="costCenter2" className="form-label me-2">
                                    Unit
                                </label>
                                <Select
                                    id="costCenter2"
                                    value={formData.costCenter2}
                                    isDisabled={!!itemData?.vendorName}
                                    onChange={handleCost2}
                                    options={cost2?.map((sup) => ({ value: sup, label: sup?.description }))}
                                    className="flex-grow-1"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                />
                            </div>
                            <div className="col-md-4 d-flex align-items-center">
                                <label htmlFor="costCenter3" className="form-label me-2">{isXtreamCompany === false ? "Cost Center 3" : "Nature of Job"}</label>
                                <Select
                                    id="costCenter3"
                                    value={formData.costCenter3}
                                    isDisabled={!!itemData?.vendorName}
                                    onChange={handleCost3}
                                    options={cost3?.map((sup) => ({ value: sup, label: sup?.description }))}
                                    className="flex-grow-1"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col-md-4 d-flex align-items-center">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">{isXtreamCompany === false ? "Cost Center 4" : "Work Order No"}</label>
                                <Select
                                    id="costCenter4"
                                    value={formData.costCenter4}
                                    isDisabled={!!itemData?.vendorName}
                                    onChange={handleCost4}
                                    options={cost4?.map((sup) => ({ value: sup, label: sup?.description }))}
                                    className="flex-grow-1"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                />
                            </div>

                            <div className="col-md-4"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="slide-container p-2 mt-3">
                <div className="container-fluid">
                    <div className="nav nav-pills overslid d-flex gap-4">
                        <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`} onClick={() => handleTabClick(0)}>
                            Items
                        </div>
                        <div className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`} onClick={() => handleTabClick(1)}>
                            Authorization
                        </div>
                        {/* <div className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`} onClick={() => handleTabClick(2)}>
                            Terms
                        </div> */}
                        <div className={`dashitems sidebar-text center  ${activeTab === 3 ? 'sideActive' : ''}`} onClick={() => handleTabClick(3)}>
                            Recommendation
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid-1 brderbox2 p-4 mb-3">

                {gridVisibility[0] && (
                    <ItemGrid setLoader={setLoader} loder={loder} apiData={apiData}
                        onRequisitionData={handleRequisitionData}
                        itemData={itemData} itemList={itemList}
                        selectedCheck={isVatExcluded}
                        handleVatChange={handleVatChange}
                        isDiscountPercentage={isDiscountPercentage}
                        currencyPrecision={currencyPrecision?.precision || 3}
                    />
                )}
                {gridVisibility[1] && <Authorization handleAuthorization={handleAuthorization} usersDetails={usersDetails} setUser={setUser} itemData={itemData} />}
                {/* {gridVisibility[2] && (
                    <div className="grid-3 border">
                        <MessageGrid handleMessage={handleMessage} />
                    </div>
                )} */}
                {gridVisibility[3] && (
                    <div className="grid-3 border">
                        <MessageGrid handleMessage={handleMessage} />
                    </div>
                )}
            </div>
            <div>
                <Attachment
                    open={attachmentModal}
                    onClose={closeModal}
                    documentNo={poNumber}
                    rows={attachments}
                    readOnly={isReadOnly}
                    onFileSelect={handleFileSelect}
                    onRemarkChange={handleRemarkChange}
                    onDelete={handleDelete}
                    onView={handleView}
                    onSave={handleUpload}
                    previewImage={previewImage}
                    previewOpen={previewModal}
                    closePreview={() => setPreviewModal(false)}
                />
            </div>
            <Modal size="md" show={docModal} onHide={() => setDocModal(false)} backdrop="static" contentLabel="Doc Id Modal">
                <Modal.Header closeButton>
                    <Modal.Title className="center">Purchase Order Number</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="text-danger">The Purchase Order number already exists. Click "Generate" to assign a new number.</p>
                </Modal.Body>
                <Modal.Footer className="end p-3">
                    <button className="mainbtnGry" onClick={onCloseModal}>
                        Cancel
                    </button>
                    <button className="mainbtnRed" onClick={GenerateNumber}>
                        Generate
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default CreatePurchaseOrderTwo;